import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getChats = async () => {
  return await apiClient.get(ENDPOINTS.CHATS);
};
